import { ICustomerDetails } from "@interface/customerDetails/ICustomerDetails";
import { mapEirSalesContactDetails } from "../mappers/mapEirSalesContactDetails";
import { fetcher } from "@utils/fetcher";
import { IFetchOptions } from "itsf-ui-common";
import { getContactDetailsRoute } from "@api-routes/eirSalesFacade";

export const getContactDetails = (contactUuid: string, options: IFetchOptions = {}) =>
    fetcher<ICustomerDetails>(getContactDetailsRoute(contactUuid), {
        method: "GET",
        mapper: mapEirSalesContactDetails,
        ...options,
    });
